"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Hogyan működik a foglalási rendszer?",
  answer: "Platformunk egy integrált keresőmotort használ, amely valós időben hasonlítja össze a legnagyobb szolgáltatók ajánlatait. Ön kiválasztja az úti célt, mi pedig a legjobb árakat és elérhetőségeket mutatjuk meg közvetlenül a partneroldalakról."
}, {
  question: "Vannak rejtett költségek a foglalás során?",
  answer: "Nincsenek. Az általunk megjelenített árak tartalmazzák az alapvető adókat és illetékeket. A 'white label' technológiánk biztosítja, hogy pontosan ugyanazt az árat lássa, amit a szolgáltató saját oldalán is találna."
}, {
  question: "Milyen típusú szállásokat találhatok az oldalon?",
  answer: "A kínálatunk a luxus hotelektől kezdve a hangulatos apartmanokon át a kedvező árú hostelekig terjed. Több millió szálláshely közül válogathat világszerte, legyen szó üzleti útról vagy családi nyaralásról."
}, {
  question: "Hogyan tudom módosítani vagy lemondani a foglalásomat?",
  answer: "Mivel rendszerünk közvetítőként működik, a módosításokat és lemondásokat a visszaigazoló e-mailben található linken keresztül, közvetlenül a szolgáltató felületén tudja intézni a választott csomag feltételei szerint."
}, {
  question: "Elérhető taxi vagy transzfer szolgáltatás is?",
  answer: "Igen, a repülőjegy és szállás mellett dedikált taxi és reptéri transzfer foglalási modullal is rendelkezünk, így a teljes utazását egyetlen felületen keresztül megtervezheti és leszervezheti."
}];
export default function CommonQuestions() {
  return <section data-section-id="224143" id="gyakori-kérdések" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-secondary mb-4">
            Gyakori Kérdések
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Minden, amit a modern utazási platformunkról és a foglalási folyamatról tudni érdemes.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="bg-card border border-border rounded-lg px-4 shadow-md transition-shadow hover:shadow-lg">
              <AccordionTrigger className="font-default font-semibold text-left text-base md:text-lg hover:no-underline hover:text-primary transition-colors py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5 font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}